import { useTranslation } from 'react-i18next'
import Button from '@/shared/components/Button/Button'
import { useScheduleSave } from '../../hooks/useScheduleSave'
import styles from './ScheduleSaveStatus.module.scss'

/**
 * The one thing the schedule toolbar still says about saving: which week did
 * not reach the server.
 *
 * Everything else is a toast, a write that succeeded says so once and gets
 * out of the way, and progress is nobody's business. A failure is the
 * exception, and deliberately NOT left to the toast that announces it: that
 * toast fades after five seconds and the week stays unsaved. This is the only
 * thing that still says so afterwards, and the only route back to a retry.
 *
 * Mounted for every view, including payroll: it carries the autosave engine,
 * and unmounting it while a write was still pending would drop that write.
 */
function ScheduleSaveStatus() {
  const { t } = useTranslation()
  const { unsavedWeeks, retry, isEnabled } = useScheduleSave()

  // Nothing is written while the endpoints are switched off, so there is no
  // state to report, the roster is local by design in that mode.
  if (!isEnabled || !unsavedWeeks.length) return null

  return (
    <div className={styles.status}>
      <i
        className={`las la-exclamation-circle icon-medium ${styles.iconError}`}
      />
      <span className={`body-medium ${styles.label} ${styles.labelError}`}>
        {t('SCHEDULE.SAVE_FAILED')}
      </span>
      <Button
        label={t('SCHEDULE.RETRY_SAVE')}
        variant="text"
        color="primary"
        icon="las la-redo-alt"
        onClick={retry}
      />
    </div>
  )
}

export default ScheduleSaveStatus
